<app-spinner-service *ngIf="loading"></app-spinner-service>

<div class="detail-page-wrapper p-4" *ngIf="!loading && linhaExtrato">
  <div class="detail-card">
    <div class="detail-header">
      <div class="header-icon"><i class="pi pi-list"></i></div>
      <div class="header-info">
        <h2 class="detail-title">Linha do Extrato</h2>
        <p class="detail-subtitle">{{ formatarDataOperacao(linhaExtrato.dataOperacao) }} · {{ getTipoTransacaoLabel(linhaExtrato.tipoTransacao) }}</p>
      </div>
    </div>

    <div class="resumo-valores">
      <div class="valor-card valor-card--neutro">
        <div class="valor-card__icon"><i class="pi pi-dollar"></i></div>
        <div class="valor-card__content">
          <span class="valor-card__label">Valor</span>
          <span class="valor-card__value">{{ linhaExtrato.valor | currency:'BRL' }}</span>
        </div>
      </div>
    </div>

    <div class="info-section">
      <div class="section-title"><i class="pi pi-info-circle"></i><span>Informações da Transação</span></div>
      <div class="detail-grid">
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-calendar"></i><span>Data da Operação</span></div>
          <div class="detail-value">{{ formatarDataOperacao(linhaExtrato.dataOperacao) }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-tag"></i><span>Tipo de Transação</span></div>
          <div class="detail-value">{{ getTipoTransacaoLabel(linhaExtrato.tipoTransacao) }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-money-bill"></i><span>Moeda</span></div>
          <div class="detail-value">{{ linhaExtrato.moeda || '—' }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-hashtag"></i><span>Código da Transação</span></div>
          <div class="detail-value">{{ linhaExtrato.codigoTransacao || '—' }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-check-square"></i><span>Número de Verificação</span></div>
          <div class="detail-value">{{ linhaExtrato.numeroVerificacao || '—' }}</div>
        </div>
        <div class="detail-item full-width">
          <div class="detail-label"><i class="pi pi-align-left"></i><span>Descrição</span></div>
          <div class="detail-value">{{ linhaExtrato.descricao || '—' }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <button pButton label="Voltar" icon="pi pi-arrow-left" class="p-button-secondary" (click)="onBack()"></button>
  </div>
</div>
